/*--------------------------------------------------
Script name: 	   Core
Author:			   Craig Collins
Version:		   1.0.1
Created:	       11/08/2015
Notes:             Core functionality library - functions added and removed to customise for City and Guilds
------------------------------------------------*/
var Core = (function () {
    'use strict';
    var core = {};
    core.bindEvent = function (el, eventName, eventHandler) {
        /// <summary>
        /// Binds a given event to a given element
        /// </summary>
        /// <param name="el" type="HTMLElement"></param>
        /// <param name="eventName" type="function"></param>
        /// <param name="eventHandler" type="event"></param>
        if (el.addEventListener) {
            el.addEventListener(eventName, eventHandler, false);
        } else if (el.attachEvent) {
            el.attachEvent('on' + eventName, eventHandler);
        }
    };
    core.debounce = function (func, wait, immediate) {
        /// <summary>
        /// Binds a given event to a given element
        /// </summary>
        /// <param name="el" type="HTMLElement"></param>
        /// <param name="eventName" type="function"></param>
        /// <param name="eventHandler" type="event"></param>
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    core.equalHeights = function (els) {
        /// <summary>
        /// Equalise the height of an array of elements
        /// </summary>
        /// <param name="els" type="array">Array of HTML Elements</param>
        var i, height = 0;
        for (i = 0; i < els.length; i++) {
            var elHeight = $($(els)[i]).height();
            if (elHeight > height) {
                height = elHeight;
            }
        }
        $(els).height(height);
    };
    return core;

})();